import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { filter, take, takeUntil } from 'rxjs/operators';
import { LoggedInUserSettings } from 'src/app/core/services/settings/logged-in-user-settings';
import { UserClaims } from 'src/app/model/okta/userClaims';
import { CHAT, CHATGROUP, PERKSGROUP, WIFISPEEDCHECK } from '../../../../core/constants/feature-key.constants';
import { ContractGuard } from '../../../../core/guards/contract.guard';
import { FeatureGuard } from '../../../../core/guards/feature.guard';
import { ADPResourceService } from 'digital-core';
import { IPromoSlot } from 'src/app/model/promos/IPromoSlot';

declare const iFrameResize;

@Component({
  selector: 'pgh-speed-test',
  templateUrl: './speed-test.component.html',
  styleUrls: ['./speed-test.component.scss']
})
export class SpeedTestComponent implements OnInit, OnDestroy, AfterViewInit {
  constructor(
    private sanitizer: DomSanitizer,
    private loggedInUserSettings: LoggedInUserSettings,
    private featureGuard: FeatureGuard,
    private contractGuard: ContractGuard,
    public resourceService: ADPResourceService,
  ) { }

  @ViewChild('speedTestFrame') speedTestFrame: ElementRef;

  isPromotionDisabled = false;
  public promoSlot: IPromoSlot;
  urlSafe: SafeResourceUrl;
  url: string;
  userData: UserClaims;
  isLoaded: boolean = true;
  private destroy$ = new Subject<boolean>();
  dealerCode: string;
  isTechServicesChatEnabled: boolean = false;
  cancelledOrExpiredHasFullAccess: boolean = false;

  ngOnInit() {
    this.url = this.resourceService.getPortalSetting("URL_External_Speedcheck")?.Value;
    this.cancelledOrExpiredHasFullAccess = this.resourceService.isPortalSettingTrue('Global_CancelledOrExpiredContract_HasFullAccess');
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    this.loggedInUserSettings.$selectedContract.pipe(
      filter(contract => !!contract),
      takeUntil(this.destroy$)
    ).subscribe(contract => {
      this.isPromotionDisabled = (contract.isCancelled || contract.isExpired) && !this.cancelledOrExpiredHasFullAccess;
      this.isTechServicesChatEnabled = this.loggedInUserSettings.isFeatureEnabled(contract.dealerId, CHATGROUP) && this.loggedInUserSettings.isFeatureEnabled(contract.dealerId, CHAT);
      this.contractGuard.activateGuard(contract);
      this.dealerCode = contract.dealerId;
      iFrameResize({ log: false, checkOrigin: false }, '.speedtest-frame');
    });

    this.loggedInUserSettings.$userClaims.pipe(take(1))
      .subscribe(user => this.userData = user);

    window.scrollTo(0, 0);
    this.promoSlot = {
      heading: 'SpeedTest_Promo_Heading',
      promoText: 'SpeedTest_Promo_Text',
      secondaryHeader: 'SpeedTest_Promo_Secondary_Header',
      secondaryText: 'SpeedTest_Promo_Secondary_Text',
      imageKey: 'Global_Dashboard_Promo_TechSupport_ImageKey',
      callToActionLabel: 'SpeedTest_Promo_CallToAction_Button_Label',
      isPromoAppType: this.resourceService.isPortalSettingTrue("SpeedTest_Promo_IsPromoAppType"),
    };

  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  ngAfterViewInit() {
    this.speedTestFrame.nativeElement.onload = () => {
      this.isLoaded = false;
      let isEnabled = this.loggedInUserSettings.isFeatureEnabled(this.dealerCode, PERKSGROUP);

      if (!this.loggedInUserSettings.isFeatureEnabled(this.dealerCode, WIFISPEEDCHECK)) {
        isEnabled = false;
      }

      if (isEnabled) {
        this.isLoaded = true;
        iFrameResize({ log: false, checkOrigin: false }, '.speedtest-frame');
        const data = {
          isNativeApp: 'false',
          email: this.userData.email,
          whiteLabelKey: 'pg_home'
        };
        this.speedTestFrame.nativeElement.contentWindow.postMessage(JSON.stringify(data), '*');
      } else {
        this.featureGuard.canActivate(this.dealerCode, WIFISPEEDCHECK, isEnabled);
      }
    };
  }
}
